<template>
  <section class="py-5 bg-white text-dark">
    <div class="container">
      <h1 class="mb-4 text-primary fw-bold">Atestat expert achiziții publice</h1>

      <p>
        Un <strong>expert în achiziții publice</strong> vă poate întocmi documentația necesară participării la licitații și vă poate ghida pe parcursul întregii proceduri. 
        Deși introducerea <strong>DUAE (Document Unic de Achiziții European)</strong> ar fi trebuit să simplifice lucrurile, în realitate procesul a devenit mai complex pentru ofertanți.
      </p>

      <h5 class="mt-4 fw-semibold"><i class="fas fa-file-signature me-2"></i>De ce e important un expert?</h5>
      <ul>
        <li><i class="fas fa-check me-2 text-success"></i>Evitați respingerea ofertei din cauza documentației incomplete</li>
        <li><i class="fas fa-check me-2 text-success"></i>Beneficiați de asistență pentru completarea corectă a DUAE</li>
        <li><i class="fas fa-check me-2 text-success"></i>Sprijin permanent în comunicarea cu autoritatea contractantă</li>
      </ul>

      <h5 class="mt-4 fw-semibold"><i class="fas fa-user-graduate me-2"></i>Ce presupune atestarea?</h5>
      <p>
        Obținerea atestatului de expert în achiziții publice presupune pregătire teoretică și practică. Acesta garantează că echipa care vă asistă este la curent cu toate modificările legislative.
      </p>

      <p>
        <strong>Experiența noastră</strong> în domeniul achizițiilor publice vă poate ajuta concret în câștigarea contractelor atribuite de autoritățile contractante.
      </p>

      <h5 class="mt-4 fw-semibold"><i class="fas fa-tasks me-2"></i>Distribuția sarcinilor</h5>
      <p>
        Deoarece achizițiile publice implică documente complexe și sensibile, colaborarea se desfășoară astfel:
      </p>
      <ul>
        <li><i class="fas fa-handshake me-2 text-primary"></i>Noi completăm: documentația de calificare și părți din propunerea tehnică</li>
        <li><i class="fas fa-user-check me-2 text-primary"></i>Voi furnizați: documentele specifice solicitate (Certificat Constatator, atestate, etc.), propunerea financiară și restul propunerii tehnice</li>
        <li><i class="fas fa-headset me-2 text-primary"></i>Oferim sprijin pe toată durata elaborării și depunerii ofertei – online (SEAP) sau offline</li>
      </ul>

      <h5 class="mt-4 fw-semibold"><i class="fas fa-user-plus me-2"></i>Crearea contului SEAP</h5>
      <p>
        Vă putem asista în <strong>crearea contului pe www.e-licitatie.ro (SEAP)</strong> și în configurarea profilului operatorului economic.
      </p>

      <p class="mt-4">
        Pentru asistență profesională în întocmirea ofertelor, completarea DUAE sau crearea contului SEAP, nu ezitați să ne contactați:
        <br />
        <strong><i class="fas fa-envelope me-1"></i>contact@consultantaachizitii.ro</strong>
      </p>
    </div>
  </section>
</template>

<script>
export default {
  name: 'AtestatExpert'
}
</script>
